const getters = {
  token: state => state.user.token,
  isLogin: state => !!state.user.token,
  permission_routes: state => state.permission.routes,  
  token: state => state.user.token,
  isflash: state => state.user.isflash,
  menus: state => state.user.menus,
  name: state => state.user.name,
  avatar: state => state.user.avatar,
  depts: state => state.user.depts,
  userId: state => state.user.userId,
  mobile:  state => state.user.mobile,
  userInfo: state => state.user.userInfo,
  mMenus: state => state.user.mMenus,
  cMenus: state => state.user.cMenus,
  fMenus: state => state.user.fMenus,
  identity: state => state.user.identity,
  sidebar: state => state.app.sidebar,
  lastRow: state => state.user.lastRow,
  parentRows: state => state.user.parentRows,
  roles: state => state.user.roles,
  companys: state => state.user.companys,
  signUserInfo: state => state.sign.userInfo,
  txSn: state => state.sign.txSn
}
export default getters